import * as types from '../mutation-types'

const state = {
    employeeId: 0,
    employeeName: "",
    employeeType: "",
    employeeDetails: [],
    addEmpPersonal: '',


}

const getters = {
    currentEmployeeID: state => state.employeeId,
    currentEmployeeName: state => state.employeeName,
    currentEmployeeType: state => state.employeeType,
    currentEmployeeDetails: state => state.employeeDetails
}

const actions = {
    selectEmployee({
        commit,
        state
    }, data) {
        commit(types.CHANGE_CURRENT_EMPLOYEE_ID, {
            'data': data
        })
    },
    setEmployeeDetails({
        commit,
        state
    }, data) {
        commit(types.CHANGE_EMPLOYEE_DETAILS, {
            'data': data
        })
    },
    saveEmployeeBasicInfo({
        commit,
        state
    }, data) {
        commit(types.SET_ADD_EMPLOYEE_BASIC_INFO, {
            'data': data
        })
    }
}
const mutations = {
  [types.CHANGE_CURRENT_EMPLOYEE_ID](state, {
        data
    }) {

        state.employeeId = data.id;
        state.employeeName = data.name;
        state.employeeType = data.type;
        //console.log(data);

    },
  [types.CHANGE_EMPLOYEE_DETAILS](state, {
        data
    }) {
        state.employeeDetails = data;
    },
  [types.SET_ADD_EMPLOYEE_BASIC_INFO](state, {
        data: data
    }) {
        state.addEmpPersonal = data;
        //console.log(data);
    },
   
}
export default {
    state,
    getters,
    actions,
    mutations

}
